module.exports = __webpack_public_path__ + "static/media/cisco_spark_logo.684ddbb9.jpg";